import { LOCALES } from "./locales";
import { getEnvironmentMode } from "@/utils/env";
import { ILA26_IntlMessages } from "@ila-26/ui-kit-open-source";
import lodash from "lodash";

import * as commonMessages from "./common";
import * as energieMessages from "./energie";
import * as foodMessages from "./food-wld";
import * as propertyMessages from "./property";
import * as healthCareMessages from "./health-care";
import * as AutoMessages from "./auto-wld";

const allMessages = {
  energie: energieMessages,
  "food-wld": foodMessages,
  property: propertyMessages,
  "hcare-wld": healthCareMessages,
  "auto-wld": AutoMessages,
};

const getEnvMessages = () => {
  const mode = getEnvironmentMode();
  return lodash.merge(commonMessages, allMessages[mode]);
};

export const getMessages = () => {
  const projectMessages = getEnvMessages();

  return {
    [LOCALES.ENGLISH]: {
      ...projectMessages.en,
      ...ILA26_IntlMessages?.en,
    },
    [LOCALES.FRENCH]: {
      ...projectMessages.fr,
      ...ILA26_IntlMessages?.fr,
    },
    [LOCALES.ARABIC]: {
      ...projectMessages.ar,
      ...ILA26_IntlMessages?.ar,
    },
    [LOCALES.SPANISH]: {
      ...projectMessages.es,
      ...ILA26_IntlMessages?.es,
    },
  };
};

export const messages = getMessages();
